export default "__VITE_ASSET__B13_zm$1__"